import { normalizeBoolean } from '@change-corgi/config/fcm/normalizers';

import { createFcmConfig } from '../shared/factory';

export const FCM_GROWTH_MEMBERSHIP_UI_UPDATE = createFcmConfig('growth_membership_ui_update', {
	normalizer: normalizeBoolean,
	defaultValue: false,
});
